import makeStyles from '@material-ui/core/styles/makeStyles';
import createStyles from '@material-ui/core/styles/createStyles';
import { Theme } from '@material-ui/core/styles';

export const useStyles = makeStyles((theme: Theme) => {
    const spacing6 = theme.spacing(6);
    return createStyles({
        logo: {
            height: '60px',
            width: 'auto',
            marginTop: theme.spacing(5),
            marginBottom: theme.spacing(3),
        },
        buttonStyles: {
            marginTop: spacing6,
            marginBottom: spacing6,
        },
        emailText: {
            color: '#717A83',
            '& .click-here-text': {
                cursor: 'pointer',
                color: theme.palette.primary.main,
            },
        },
        blackBox: {
            display: 'inline-block',
            borderRadius: 4,
            padding: theme.spacing(3, 5),
            color: '#E3E3E3',
            backgroundColor: '#323232',
        },
        reSended: {
            marginTop: 194,
            marginBottom: spacing6,
        },
        bottomNullDiv: {
            marginTop: 194,
        },
    });
});